import Layout from './layout/Layout'
import './css/adminlte.css'
import './css/App.css'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { UserContextProvider } from '../app/auth/UserContext'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getUserProfile } from './auth/profile'
import SessionTimeout from './auth/SessionTimeout'
import { CacheContextProvider } from './cache/CacheContext'
import { RoleContextProvider } from './auth/RoleContext'
import { FeatureFlagsContextProvider } from './config/FeatureFlagsContext'
import { getToken } from './auth/auth'
import { useLocation } from 'react-router-dom'
import { sendActivity } from './auth/activity'

const LoadingGif = require('./img/loading.gif')

function LoadingShell({message}) {
  return (
    <div
      className="tis-page"
      role="status"
      aria-busy="true"
      aria-live="polite"
      style={{ minHeight: '100vh', position: 'relative', backgroundColor: '#ecf0f5' }}
    >
      <div className="loading active">
        <div className="loading-inner">
          <img src={LoadingGif} alt="" aria-hidden="true" /> {message}
        </div>
      </div>
    </div>
  )
}

function App(props = {}) {
  const [userToken, setUserToken] = useState()
  const [user, setUser] = useState()
  const [userProfile, setUserProfile] = useState()
  const [tokening, setTokening] = useState(false)
  const [profiling, setProfiling] = useState(false)
  const location = useLocation()

  const login = useCallback(async () => {
    setProfiling(true)
    const {token, profile} = await getUserProfile()
    if (profile) {
      setUserProfile(profile)
    }
    setProfiling(false)
    
    setUserToken(token)
    const claims = token?.idTokenClaims
    setUser({
      koId: claims?.koId,
      name: claims?.name,
      email: claims?.mail,
      department: claims?.department,
      userName: claims?.preferred_username ?? claims?.username
    })
  }, [])

  const tokenLogin = useCallback(async () => {
    setTokening(true)
      const token = await getToken()
      if (token) {
        setUserToken(token)
        login()
      }
    setTokening(false)
  }, [login])

  useEffect(() => {
    
    if (!userToken) {
      tokenLogin()
    }
  }, [tokenLogin, userToken])

  useEffect(() => {
    if (userToken) {
      if (location?.pathname?.endsWith('/unsubscribe')) {
        return
      }
      const apd = {
        eventId: window.crypto.randomUUID(),
        clientTs: new Date(),
        eventType: 'nav',
        app: 'web',
        event: {
          ...location
        }
      }
      sendActivity(apd)
    }
  }, [location, userToken])

  const isStarting = tokening || profiling
  const startupMessage = profiling ? 'Loading your profile ...' : 'Loading, please wait ...'

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Fragment>
      {isStarting &&
        <LoadingShell message={startupMessage} />
      }
      {userToken && userProfile &&
      <UserContextProvider uniqueId={ userToken.uniqueId} {...user} userProfile={userProfile}>
        <RoleContextProvider>
          <CacheContextProvider>
          <FeatureFlagsContextProvider>
            <Layout {...props} authenticated={true} userProfile={userProfile} />
            <SessionTimeout token={userToken} profile={userProfile} />
          </FeatureFlagsContextProvider>
          </CacheContextProvider>
        </RoleContextProvider>
      </UserContextProvider>
      }
      {userToken && !userProfile && !profiling &&
      <UserContextProvider uniqueId={ userToken.uniqueId} {...user}>
            <Layout {...props} authenticated={true} />
            <SessionTimeout token={userToken} />
      </UserContextProvider>
      }
      {!userToken && !tokening &&
        <FeatureFlagsContextProvider>
          <Layout {...props} authenticated={false} />
        </FeatureFlagsContextProvider>
      }
    </Fragment>
    </LocalizationProvider>
  )
}

export default App
